<template>
  <svg id="icono-eliminar" xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 40 40">
    <rect id="Rectángulo_724" data-name="Rectángulo 724" :width="width" :height="height" fill="none"/>
    <g id="Icon_feather-trash-2" data-name="Icon feather-trash-2" transform="translate(2.9 3)">
      <path id="Trazado_7340" data-name="Trazado 7340" d="M4.5,9H29.7" transform="translate(0 -0.4)" fill="none" :stroke="color" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
      <path id="Trazado_7341" data-name="Trazado 7341" d="M27.1,8.6V28.2A2.8,2.8,0,0,1,24.3,31h-14a2.8,2.8,0,0,1-2.8-2.8V8.6m4.2,0V5.8A2.8,2.8,0,0,1,14.5,3h5.6a2.8,2.8,0,0,1,2.8,2.8V8.6" transform="translate(-0.2 0)" fill="none" :stroke="color" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
      <path id="Trazado_7342" data-name="Trazado 7342" d="M15,16.5v8.4" transform="translate(-0.7 -0.9)" fill="none" :stroke="color" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
      <path id="Trazado_7343" data-name="Trazado 7343" d="M21,16.5v8.4" transform="translate(-1.1 -0.9)" fill="none" :stroke="color" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: '#5a6b8e'
    },
    height: String,
    width: String
  }
}
</script>
